//OPEN PACKAGES DROPDOWN

var surveyForm = $('.survey-form form');
var surveyFormInputs = $('.survey-form input, .survey-form select, .survey-form textarea');

//PURCHASE FORM LOGIC

if ($('.survey-form').length > 0) {
    $('select[name^=club]').select2({
        width: '100%',
        placeholder: $(this).data('placeholder'),
        minimumResultsForSearch: Infinity,
        multiple: true
    }).on('select2:opening select2:closing', function( event ) {
        var $searchfield = $(this).parent().find('.select2-search__field');
        $searchfield.prop('disabled', true);
    });
}

$('input[name=radio-injuries][value=yes]').on('click', function () {
    $('.textarea-injuries').show();
});

$('input[name=radio-injuries][value=no]').on('click', function () {
    $('.textarea-injuries').hide().removeClass('error');
});

surveyFormInputs.on('change keyup keydown keypress', function(){

    var wrap = $(this).closest('.input, .checkboxes, .textarea-wrap');

    wrap.removeClass('error');

    wrap.find('.error-explain').remove();

});

surveyForm.on('submit', function (e) {
    e.preventDefault();

    var form = $(this),
        inputs = form.find('.input, .checkboxes, .textarea-wrap'),
        ready = true;

    for(var a=0; a<inputs.length; a++){
        if(inputs.eq(a).hasClass('error')){
            ready = false;
        }
    }

    if(!ready){
        return false;
    }

    surveyForm.addClass('loading');

    var data = form.serialize();

    pd = new FormData();
    pd.append('action', 'validate_survey_form');
    pd.append('data', data);

    $.ajax({
        type: 'POST',
        url: postre['ajax_url'],
        data: pd,
        dataType: 'json',
        contentType: false,
        processData: false,
        success: function (response) {

            var data = response.data;

            if(data.hasErrors){

                var errors = data.errors;

                for(var a=0; a<errors.length; a++){
                    var error = errors[a];

                    var input = form.find('[name^='+ error['input'] +']');

                    var wrap = input.closest('.input, .checkboxes, .textarea-wrap');

                    wrap.addClass('error');

                    wrap.prepend('<div class="error-explain">'+ error['error'] +'</div>');
                }

                $([document.documentElement, document.body]).animate({
                    scrollTop: $('body').find('.error').offset().top - 150
                }, 1000);

                surveyForm.removeClass('loading');

            } else {

                $('body').addClass('fixed');

                $('.survey-success').addClass('reveal').one(transitionEvent, function (e) {
                    $('.survey-success .survey-box-outer').addClass('reveal');
                })

            }
        },
        error: function (response) {

        }
    });

});
